export enum Routes {
  LoginPage = "/login",
  RegistrationPage = "/registration",
  ForgotPasswordPage = "/forgot-password",
  HomePage = "/",
  OfflinePage = "/offline",
  UnauthorizedPage = "/unauthorized",
}
